export default __webpack_public_path__ + "static/media/key.31eea260.svg";